import React from 'react';

import AddCommerceLink
  from 'components/dashboard/commerce-content/AddCommerceLink';
import CommerceLinksList
  from 'components/dashboard/commerce-content/CommerceLinksList';

import './CommercePageContent.css';

const CommercePageContent = () => (
  <div className="commerce-page-content__component">
    <AddCommerceLink />
    <CommerceLinksList />
  </div>
);

export default CommercePageContent;
